import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#page-header" }),
    /*#__PURE__*/_createTextVNode(" PageHeader ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " If path of the page is simple, it is recommended to use PageHeader instead of the Breadcrumb. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasic = _resolveComponent("EUIBasic")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasic)
  ], 64))
}